import { actionPrefixer } from 'shared/utils/utils';

const prefix = actionPrefixer('WORKFLOWS');

export const FETCH_WORKFLOWS = prefix('FETCH_WORKFLOWS');
export const HANDLE_WORKFLOWS_FETCH = prefix('HANDLE_WORKFLOWS_FETCH');
export const GET_WORKFLOW = prefix('GET_WORKFLOW');

export const CREATE_WORKFLOW = prefix('CREATE_WORKFLOW');

export const DELETE_WORKFLOW = prefix('DELETE_WORKFLOW');

export const EDIT_WORKFLOW = prefix('EDIT_WORKFLOW');

export const GET_WORKFLOW_API_CREDENTIALS = prefix('GET_WORKFLOW_API_CREDENTIALS');
export const ADD_API_CREDENTIALS_TO_WORKFLOW = prefix('ADD_API_CREDENTIALS_TO_WORKFLOW');
